import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { FooterLinks, SocialTemplate, makeNewFooterLinks } from 'globals/store/publish.data';
import { Wrapper } from '../wrapper.component';
import { JoiAccount } from 'globals/store/accounts.data';
import { SocialLink } from 'globals/store/entity.shared.data';
import { LinksDialogComponent, LinksDialogData } from '../dialogues-general/links.dialog.component';
import { JoiFile } from 'globals/store/files.model';
import { FooterLinksComponent } from './footer-links.component';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { CommonModule } from '@angular/common';
import { BrandingControlsWrapperComponent } from './brand-controls-wrapper.component';

@Component({
    selector: 'brand-footer-links-editor',
    template: `
<branding-controls-wrapper
  [selected]="selectedId === 'empty'"
  [isAccountDefault]="account.footerLinksId === 'empty'"
  [hideDelete]="true"
  [onAccount]="onAccount" 
  (setAsAccountDefault)="setAsAccountDefault.emit('empty')"
  (select)="select.emit('empty')"
><div class="empty-template-title">No Footer Links</div>
</branding-controls-wrapper>
<branding-controls-wrapper *ngFor="let footerLinks of account.footerLinks"
  [selected]="selectedId === footerLinks.id"
  [isAccountDefault]="account.footerLinksId === footerLinks.id"
  [deleteTitle]="deleteTitle" 
  [canRemove]="true"
  [onAccount]="onAccount"
  (unselect)="select.emit(null)"
  (delete)="deleteTemplate(footerLinks.id)"
  (setAsAccountDefault)="setAsAccountDefault.emit(footerLinks.id)"
  (select)="select.emit(footerLinks.id)"
>
  <joi-input class="big-title"
    [italicPlaceholder]="true"  
    [disabled]="!onAccount"
    [type]="'textarea'"  
    [(model)]="footerLinks.name" [placeholder]="'Footer links set name...'" (joiChange)="updateTemplates()"
  ></joi-input>
  <footer-links [footerLinks]="footerLinks"></footer-links>
  <div class="secondary_link delete" *ngIf="!!onAccount" (click)="updateFooterLinks(footerLinks)">+ Edit Footer Links</div>
</branding-controls-wrapper>
<button mat-button class="large" *ngIf="onAccount" (click)="addTemplate()">+ Add a footer links set</button>
`,
    styles: [`
  branding-controls-wrapper { margin-bottom: 20px; display: block; }
  .big-title { margin-top: 10px; }
  .delete { margin-bottom: 5px; }
`],
    standalone: true,
    imports: [FooterLinksComponent, JoiInputComponent,CommonModule,BrandingControlsWrapperComponent],
})
export class BrandFooterLinksEditorComponent extends Wrapper<BrandFooterLinksEditorComponent> {
  _file = 'brand-footer-links-editor'
  @Input() onAccount: boolean = false
  @Input() selectedId: string
  @Input() accountDefaultId: string
  @Input() account: Partial<JoiAccount>

  @Output() select: EventEmitter<string> = new EventEmitter()
  @Output() setAsAccountDefault: EventEmitter<string> = new EventEmitter()

  deleteTitle: string = 'Delete Footer Links Template'

  constructor() {
    super()
  }
  
  saveSocialLinks(links: SocialLink[], template: SocialTemplate) {
    template.social = links
    this.accountService.updateAccount(this.account.id, { socialTemplates: this.account.socialTemplates }, { file: this._file, function: 'saveSocialLinks', error: new Error(), message: 'There was an error saving a template' })
  }

  addTemplate() {
    const footerLinks = this.account.footerLinks
    footerLinks.push(makeNewFooterLinks())
    this.accountService.updateAccount(this.account.id, { footerLinks }, { file: this._file, function: 'addTemplate', error: new Error(), message: 'There was an error adding a template' })
  }

  deleteTemplate(deleteId: string) {
    const footerLinks = this.account.footerLinks.filter(fl => fl.id !== deleteId)
    this.account.footerLinks = footerLinks
    this.accountService.updateAccount(this.account.id, { footerLinks }, { file: this._file, function: 'deleteTemplate', error: new Error(), message: 'There was an error deleting a template' })
  }

  updateTemplates() {
    this.accountService.updateAccount(this.account.id, { footerLinks: this.account.footerLinks }, { file: this._file, function: 'updateTemplates', error: new Error(), message: 'There was an error updating the account templates' })
  }

  async updateFooterLinks(footerLinks: FooterLinks) {
    const data: LinksDialogData = {
      links: footerLinks.links,
      dialogTitle: 'Footer Links',
      linkType: 'Footer Links',
      description: 'Add footer links',
      linksTitle: 'Footer Links',
      linksEmptyText: 'No footer links',
      addLinkText: 'ADD A FOOTER LINK',
      namePlaceholder: 'Footer link text',
    }
    
    const newLinks: JoiFile[] = await this.openDialogGetResult<JoiFile[]>(LinksDialogComponent, { width: '480px', disableClose: true, data })
    console.log({ newLinks })
    if (!newLinks) return // returns null for cancel or no changes, [] if removed all so this won't hit
    
    footerLinks.links = newLinks
    this.updateTemplates()

  }

}

